import { Recurrence } from '@tableau/self-service-schedules';
import { DropdownButton, DropdownButtonType } from '@tableau/widgets';
import React, { useRef } from 'react';

import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';

import { Messages } from '../../codegen/Localize';
import { FlowTaskSelfServiceSchedulePickerPopup } from './FlowTaskSelfServiceSchedulePickerPopup';

export type FlowTaskSelfServiceSchedulePickerProps = {
  onScheduleSave: (frequency: Recurrence) => void;
  scheduledTaskFrequency: Recurrence;
}

export function FlowTaskSelfServiceSchedulePicker(props: FlowTaskSelfServiceSchedulePickerProps): JSX.Element {
  const dropdownId = 'flow-self-service-schedule-dropdown';
  const dropdownButtonRef = useRef(null);

  return (
    <DropdownButton
      label=''
      aria-controls={dropdownId}
      aria-haspopup={'dialog'}
      type={DropdownButtonType.Outline}
      popupContent={
        <div role='dialog' id={dropdownId}>
          <FlowTaskSelfServiceSchedulePickerPopup
            onScheduleSave={props.onScheduleSave}
            scheduledTaskFrequency={props.scheduledTaskFrequency}
            dropdownButtonRef={dropdownButtonRef}
          />
        </div>
      }
      testId={'FlowSelfServiceScheduleDropdownButton'}
      ref={dropdownButtonRef}
    >
      {props.scheduledTaskFrequency ?
        `${Messages.capability_execute_flow()}: ${IScheduleInfo.getRecurrenceDescription(props.scheduledTaskFrequency)}` :
        Messages.defineASchedule()}
    </DropdownButton>
  );
}
